import React from "react";
import "./ECADIntegration.css";
import ECADIntegrationOverview from "./ECADIntegrationOverview";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import { NavLink } from "react-router-dom";
import BannerImage from "../../../assets/other_image/intigretion.jpg";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import { Helmet } from "react-helmet-async";

const ECADIntegration = () => {
  return (
    <>
      {/* ⭐ Correct SEO for MCAD Integration (as you provided) */}
  
<Helmet>
  <title>ECAD Integration with Teamcenter in Pune | Nextech PLM</title>
  <meta
    name="description"
    content="Seamlessly integrate your ECAD tools with Teamcenter for efficient product lifecycle management. Nextech PLM offers expert ECAD integration services in Pune and across India. Boost your engineering productivity today – Get in touch!"
  />
</Helmet>


      <section className="ECADIntegration-management">

        <Banner
          image={BannerImage}
          heading="ECAD Integration with Teamcenter"
        />

        <FloatingContactUs />

        {/* Overview Section */}
        <ECADIntegrationOverview />

        {/* Unlock the Power Section */}
        <section style={{ background: "#f5f7fa" }}>
          <div className="benefits container">
            <h4 className="ECADIntegration-page-heading">Unlock the Power :</h4>
            <h5 className="ECADIntegration-subheading">
              Discover the Transformative Benefits of ECAD Integration with NexTech!
            </h5>
            <ul className="custom-bullets">
              <li>Associative development of mechanical, electrical, electronic, and embedded software technologies.</li>
              <li>Efficient management of Mechatronics data files supporting complete design through the manufacturing process.</li>
              <li>Consistent work processes across all data formats.</li>
              <li>Elimination of late discovery of cross-domain integration issues.</li>
            </ul>
          </div>
        </section>

        {/* Solutions Section */}
        <section>
          <div className="solutions container">
            <div className="solutions-content">
              <div className="row">
                <div className="col-md-6 col-12">
                  <h4 className="ECADIntegration-page-heading">Solutions</h4>
                  <ul className="custom-bullets">
                    <li>Implementation of Teamcenter Gateway for EDA</li>
                    <li>Integration of ECAD part libraries</li>
                    <li>Seamless integration of ECAD designs</li>
                    <li>2TIER & 4TIER integration of Clear Case, Mentor, Cadence, Capital Harness, Zuken, MATLAB & Simulink</li>
                  </ul>
                  <p className="plmimplementationparagraph">
                    These services efficiently map business requirements in Teamcenter, enabling optimal configuration and integration of electronic design, software lifecycle, system engineering, and wire harness management tools.
                  </p>
                </div>

                {/* Quick Links */}
                <div className="col-md-6 col-12">
                  <div className="quick-links">
                    <h4>Quick Links</h4>
                    <ul>
                      <li><NavLink to={"/teamcenter/mcad-integration"}>MCAD Integration</NavLink></li>
                      <li><NavLink to={"/teamcenter/cybersecurity"}>Teamcenter Cyber Security</NavLink></li>
                      <li><NavLink to={"/teamcenter/manufacturing-data-process-management"}>Manufacturing Data & Process Management</NavLink></li>
                      <li><NavLink to={"/teamcenter/implementation"}>Teamcenter Implementation</NavLink></li>
                      <li><NavLink to={"/teamcenter/cae-integration"}>CAE Integration</NavLink></li>
                      <li><NavLink to={"/teamcenter/cam-integration"}>CAM Integration</NavLink></li>
                      <li><NavLink to={"/teamcenter/upgrade-migration"}>Upgrade & Migration</NavLink></li>
                      <li><NavLink to={"/teamcenter/aw-client"}>AW Client Implementation</NavLink></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Best Practices Section */}
        <section style={{ background: "#f5f7fa" }}>
          <div className="best-practices container">
            <h4 className="ECADIntegration-page-heading">Best Practices</h4>
            <p className="plmimplementationparagraph">
              We enable best practices across Clear Case, Mentor, Cadence, Capital Harness, Zuken, MATLAB, Simulink environments including BOM management, dependency mapping, function relations, product configuration & visualization.
            </p>
            <h5 className="performance-tuning">Performance Tuning:</h5>
            <p className="plmimplementationparagraph">
              We ensure optimal performance through correct configuration of OS, hardware, servers & client systems for smooth manage-mode operations.
            </p>
          </div>
        </section>

        {/* Why NexTech Section */}
        <section>
          <div className="why-nextech container">
            <h4 className="ECADIntegration-page-heading">Why NexTech?</h4>
            <h5 className="ECADIntegration-subheading">For ECAD Integration Solutions</h5>
            <ul className="custom-bullets">
              <li>Associative multi-domain engineering across mechanical, electrical & software.</li>
              <li>Complete mechatronics data lifecycle control.</li>
              <li>Consistency across all ECAD/MCAD formats.</li>
              <li>Preventing costly cross-domain issues early.</li>
              <li>Expertise in Gateway for EDA, library integration, ECAD design integration & multi-tier connections.</li>
            </ul>
          </div>
        </section>

        {/* Contact Section */}
        <Letsgetintouch />

      </section>
    </>
  );
};

export default ECADIntegration;
